export const navBarParam = {
  transparent: false,
};

export const header = {
  headline: "Contact",
  subheadline:
    "Feel free to contact me for sales requests or any other information.",
};
